import { Card, CardContent } from "@mui/material"
import React from "react"
import { ReviewContent } from "./reviewContent"
import { ReviewCardProps } from "./types"

export const ReviewCard = ({ cardProps, ...other }: ReviewCardProps) => {
    // const id1 = useId();
    // const id2 = useId();
    return (
        <Card variant="outlined" elevation={0} {...cardProps} sx={{ ...cardProps?.sx, height: '100%' }}>
            <CardContent sx={{ height: '100%' }}>
                <ReviewContent {...other} />
            </CardContent>
        </Card>
    )
}